import { LegalPage } from "./_legal_page";

const sections = [
  {
    title: "1. 取得する情報",
    body: [
      "当社は、本サービスの提供、改善、保守のため、アクセス日時、閲覧ページ、端末情報、ブラウザ情報、リファラ、IPアドレス、Cookie 等の技術情報を取得することがあります。",
      "本サービス上で予約や問い合わせのために外部サイトへ遷移した場合、遷移先で入力される情報は、遷移先サービスまたはサロンのプライバシーポリシーに従って取り扱われます。",
    ],
  },
  {
    title: "2. 利用目的",
    body: [
      "取得した情報は、本サービスの表示、品質改善、不具合調査、利用状況の分析、不正利用の防止、問い合わせ対応のために利用します。",
      "個人を識別できない形に加工した統計情報を、サービス改善や掲載品質の向上のために利用することがあります。",
    ],
  },
  {
    title: "3. Cookie 等の利用",
    body: [
      "本サービスでは、利便性の向上、アクセス解析、安定したサービス提供のために Cookie または類似技術を利用することがあります。",
      "利用者はブラウザの設定により Cookie を無効にできます。ただし、その場合、一部機能が正しく動作しないことがあります。",
    ],
  },
  {
    title: "4. 第三者提供",
    body: [
      "当社は、法令に基づく場合、利用者の同意がある場合、またはサービス提供に必要な範囲で委託先に取り扱いを委託する場合を除き、取得した個人情報を第三者に提供しません。",
      "外部予約サービス、地図サービス、配信基盤等の第三者サービスを利用する場合、それぞれの提供者が定める条件およびポリシーが適用されることがあります。",
    ],
  },
  {
    title: "5. 安全管理",
    body: [
      "当社は、取得した情報について、漏えい、滅失、毀損、不正アクセス等を防止するため、必要かつ適切な安全管理措置を講じます。",
    ],
  },
  {
    title: "6. 開示、訂正、利用停止等",
    body: [
      "利用者本人から、個人情報の開示、訂正、追加、削除、利用停止等の請求があった場合、当社は法令に従い適切に対応します。",
    ],
  },
  {
    title: "7. 改定",
    body: [
      "当社は、必要に応じて本ポリシーを改定することがあります。改定後の内容は、本ページに掲載された時点から適用されます。",
    ],
  },
];

export default function SalonpagePrivacy() {
  return (
    <LegalPage
      title="プライバシーポリシー"
      description="Hairbook Salon Pages における情報の取り扱いについて定めます。"
      updatedAt="2026年6月25日"
      sections={sections}
    />
  );
}
